import {Modal as BSModal} from "bootstrap";

import {EventEmitter} from "./EventEmitter";
import {helpers} from "../helpers/index";

export class Modal {
	constructor({className = "", id = ""} = {}) {
		this.$template = document.getElementById("js-modal-template");
		this.$body = document.querySelector(".body");
		this.emitter = new EventEmitter();
		this.$modal = null;
		this.modal = null;
		this.id = id ? id : new Date().getTime();
		this.className = className;
		this.needRemove = true;
		this.needCreate = true;
	}

	/**
	 * Для использования модалок которые уже есть при загрузке страницы
	 * @param id {String}
	 */
	use(id) {
		this.id = id;
		this.$modal = document.getElementById(id);
		this.modal = new BSModal(this.$modal);
		this.needRemove = false;
		this.needCreate = false;
		return this;
	}

	/**
	 * Устанавливает подписчиков на событие
	 * @param action {('hide' | 'show')}
	 * @param fn {Function}
	 */
	on(action, fn) {
		if (action === "hide") this.emitter.subscribe("hide", e => fn(e));
		if (action === "show") this.emitter.subscribe("show", e => fn(e));
	}

	/**
	 * Показывает модалку
	 * @param html {String}
	 * @param params {Object}
	 * @param params.className {String}
	 * @param params.isCentered {Boolean}
	 * @param params.keyboard {Boolean}
	 * @param params.focus {Boolean}
	 * @param params.backdrop {Boolean}
	 */
	show(
		html = "",
		{className = "", isCentered = true, keyboard = true, focus = true, backdrop = true} = {}
	) {
		if (this.needCreate) {
			if (!this.$template) throw new Error("Необходимо указать template");
			const fragment = document.importNode(this.$template.content, true);

			helpers.isHTML(html)
				? fragment.querySelector(".modal-body").insertAdjacentHTML("beforeend", html)
				: fragment.querySelector(".modal-body").append(html);
			fragment.querySelector(".i-modal").setAttribute("id", this.id);
			isCentered
				? fragment.querySelector(".modal-dialog").classList.add("modal-dialog-centered")
				: "";
			this.$body.append(fragment);
		}

		this.$modal = document.getElementById(this.id);

		this.modal = new BSModal(this.$modal, {
			keyboard,
			focus,
			backdrop,
		});

		this.modal.show();

		if (className) this.$modal.classList.add(className);
		if (this.className) this.$modal.classList.add(this.className);

		this.$modal.addEventListener("hidden.bs.modal", e => {
			this.needRemove ? this.remove(e) : "";
		});

		this.$modal.addEventListener("shown.bs.modal", e => {
			this.emitter.emit("show", e);
		});

		this.$modal.addEventListener("hide.bs.modal", e => {
			this.emitter.emit("hide", e);
		});
	}

	remove(e) {
		this.hide(e);
		this.modal.dispose();
		this.$modal.remove();
		this.modal = null;
		this.$modal = null;
	}

	hide(e) {
		this.modal.hide();
		this.emitter.emit("hide", e);
	}
}

/**
 * Информационное модальное окно
 * для случаев когда необходимо показать какое то сообщение
 * //TODO: создать методы для таких случаев: info, success, error, warning с дизайном
 * @type {{
 *  error: (content: string) => void
 * }}
 */
export const modal = {
	/**
	 * Создает и показывает новую модалку с ошибкой
	 * @param {string} content
	 */
	error: content => {
		const alert = new Modal();
		return alert.show(content);
	},
};
